module.exports = __webpack_public_path__ + "img/pencil.a87d2126.png";